import { TransportStatus } from 'requests/objects/transport'
import parseJson from 'helpers/methods/parseJson'
import Time, { getLocaleFromLang } from 'helpers/methods/time'
import { isValidDate } from 'helpers/methods/common'
import { Translations } from 'types/translations'

const REG_END_BY_DATE = /(Date|DateStart|DateEnd)$/
const getTranslatedValue = (obj, lang) => {
    if (typeof obj === 'string')
        return obj

    return obj?.[lang]
        ?? obj?.en
        ?? obj?.fr
        ?? obj?.nl
        ?? ''
}

/**
 * Translate an element by an object
 * @param {'fr' | 'en' | 'nl' | string} lang Language
 * @param {import('types/translations').TranslationsObjectType | string} obj Object to translate, default to undifined to use "Translations" object
 * @param {{[key: string]: string}=} args Args to replace
 * @returns {string} Result
 */
export function wfTObj(lang, obj, args = {}) {
    const locale = getLocaleFromLang(lang)
    let translation = getTranslatedValue(obj, lang)
    Object.keys(args).forEach(key => {
        let value = args[key]

        switch (key) {
            case 'PlannedDeliveryDate': {
                const argDate = new Date(value)
                if (!isValidDate(argDate))
                    break
                if (argDate.getHours() < 13)
                    value = getTranslatedValue(Translations.deliveryMorning, lang)
                else
                    value = getTranslatedValue(Translations.deliveryAfternoon, lang)
                value = value.replace('{{date}}', Time(argDate, { locale }).getCleanDate({
                    month: 'numeric', day: 'numeric', year: 'numeric',
                }))
                break
            }
            case 'TransportReserves':
                value = getTranslatedValue(parseJson(value), lang) || value
                break
            default: {
                if (REG_END_BY_DATE.test(key)) {
                    const argDate = new Date(value)
                    if (isValidDate(argDate))
                        value = argDate.toLocaleString(locale, {
                            month: 'numeric',
                            day: 'numeric',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                        })
                }
                break
            }
        }

        translation = translation.replace(`{{${key}}}`, value)
    })

    translation = translation.replace('{{Platform}} -', '')
    translation = translation.replace(' 00:00', '')
    translation = translation.replace('{{Platform}}', '')
    translation = translation.replace('{{TransportReserves}}', '/')
    translation = translation.replace(' le {{RealDeliveryDate}}', '')
    translation = translation.replace(' on {{RealDeliveryDate}}', '')
    translation = translation.replace(' op {{RealDeliveryDate}}', '')
    translation = translation.replace(/\{\{.*?\}\}/g, '/')

    return translation
}

/**
 * get step types from transport statuses
 * @param {TransportStatus[]} transportStatuses transportStatuses
 * @param {string}isPineau isPineau
 * @param {'fr' | 'en' | 'nl' |'es' | string} lang Language
 * @returns {import("components/pages/statusData").StepType[]} stepTypes
 */
export default function getStepTypes(transportStatuses, isPineau, lang = 'en') {
    return transportStatuses.map(ts => {
        let label = wfTObj(
            lang,
            parseJson(ts.tmsTransportStatus?.label),
        )

        // test
        // dispplay "livré" of "livré:conforme" for company pineau
        if (
            isPineau
            && ts.tmsTransportStatus?.eventType === '21'
            && ts.tmsTransportStatus?.reasonType === '310'
        )
            label = getTranslatedValue(Translations.delivered, lang) || 'livré'
        // dispplay "Enlevé" of "Enlevé:conforme" for company pineau
        if (
            isPineau
            && ts.tmsTransportStatus?.eventType === '13'
            && ts.tmsTransportStatus?.reasonType === '310'
        )
            label = getTranslatedValue(Translations.picked, lang) || 'Enlevé'
        const args = {
            ...(parseJson(ts.args || '') || {}),
            ConfirmationDate: ts.date,
        }

        return {
            date: ts.date,
            label,
            subLabel: wfTObj(
                lang,
                parseJson(ts.tmsTransportStatus?.subLabel),
                args,
            ),
            type: ts.tmsTransportStatus?.type,
        }
    })
}
// To be implemented when Pineau is on Phileas TMS, display "statut delivered" instead of "delivered: compliant".
// export default function getStepTypes(transportStatuses) {
//     const lang = this?.props?.lang || 'en'

//     return transportStatuses.map(ts => ({
//         date: ts.date,
//         label: wfTObj(lang, parseJson(ts.tmsTransportStatus?.label)),
//         subLabel: wfTObj(lang, parseJson(ts.tmsTransportStatus?.subLabel), parseJson(ts.args || '')),
//         type: ts.tmsTransportStatus?.type,
//     }))
// }
